import type { NavigateFunction } from "react-router-dom";
import type { ImagingSeries } from "@/portals/patient/api/imagingStudiesApi";

export const DIAGNOSTICS_PATH = "/patient/diagnostics";

/** Router state DiagnosticsImagingSection reads to open on its Imaging tab. */
export interface DiagnosticsLocationState {
  tab?: "labs" | "imaging";
}

/** Opens one series in the DICOM viewer. The route param is the series'
 *  first member's id; the full series goes in router state so the viewer
 *  page renders the whole series immediately (see DicomViewerPage.tsx). The
 *  one way every entry point (Recent DICOM Uploads, the Imaging list, upload
 *  completion) opens a series. */
export function openSeriesViewer(navigate: NavigateFunction, series: ImagingSeries) {
  if (series.files.length === 0) return;
  navigate(`/patient/diagnostics/imaging/${series.files[0].id}`, { state: { series } });
}

/** Opens Diagnostics & Imaging on its Imaging tab (the full series list). */
export function openImagingTab(navigate: NavigateFunction) {
  const state: DiagnosticsLocationState = { tab: "imaging" };
  navigate(DIAGNOSTICS_PATH, { state });
}
